export const emailRegex: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const phoneRegex: RegExp = /^0([2378]\d{8}|[45]\d{8}|14\d{7})$/;

/** Extends phoneRegex with 1300/1800 business numbers for nomination forms. */
const phonePattern = phoneRegex.source.slice(1, -1); // strip ^ and $
export const nominationPhoneRegex: RegExp = new RegExp(`^(${phonePattern}|1(300|800)\\d{6})$`);
